import React from 'react';
import NewAssetForm from './NewAssetModal/NewAssetForm';

const EditAssetModal = ({ modalOpen, setModalOpen, asset }) => {
  if (!modalOpen || !asset) return null;

  const handleClose = () => setModalOpen(false);

  return (
    <div className={`new-asset ${modalOpen && 'open'}`}>
      <div className="content-wrapper">
        <div className="new-asset-header">
          <span>EDIT ASSET</span>
          <span style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: 18 }} onClick={handleClose}>
            ×
          </span>
        </div>
        <NewAssetForm mode="edit" initialValues={asset} onUploadComplete={handleClose} />
      </div>
    </div>
  );
};

export default EditAssetModal;
